import React from "react";
import { Route, Routes } from "react-router-dom";
import { HomePageURL } from "../assets/const";
import List from "../pages/products/List";
import Detail from "../pages/products/Detail";

const ProductRoute = () => {
  return (
    <Routes>
      <Route path={`${HomePageURL}/products/`} element={<List />} />
      <Route
        path={`${HomePageURL}/products/:productSlug/`}
        element={<Detail />}
      />
    </Routes>
  );
};

export default ProductRoute;
